import React, { useRef, useEffect } from 'react'
import { Box } from '@mui/material'

interface AuthPageWrapperProps {
  children: React.ReactNode
}

/**
 * AuthPageWrapper - Wrapper pentru toate paginile de autentificare
 * Cu background video pentru un aspect modern și profesional
 */
export const AuthPageWrapper: React.FC<AuthPageWrapperProps> = ({ children }) => {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    // Asigură-te că video-ul se redă automat și în loop
    if (videoRef.current) {
      videoRef.current.play().catch(console.error)
    }
  }, [])

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Partea stângă - Login Box compact */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          bottom: 0,
          width: '400px', // Lățime fixă compactă pentru login
          minWidth: '350px', // Minimum pentru a încăpea formularul
          backgroundColor: '#000000', // Background negru
          zIndex: 1,
          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          
          // Pe mobile: pe tot ecranul
          '@media (max-width: 768px)': {
            width: '100%',
            minWidth: 'unset',
            padding: 2,
          },
        }}
      >
        {children}
      </Box>
      
      {/* Partea dreaptă - Background Video (restul spațiului) */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '400px', // Începe după login box
          right: 0,
          bottom: 0,
          zIndex: 0,
          
          // Pe mobile: ascuns (doar login box)
          '@media (max-width: 768px)': {
            display: 'none',
          },
        }}
      >
        <Box
          component="video"
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        >
          <source src="/assets/bg_main.mp4" type="video/mp4" />
          <source src="/assets/bg_main.mov" type="video/quicktime" />
          {/* Fallback pentru browsere care nu suportă video */}
          Your browser does not support the video tag.
        </Box>
        
        {/* Overlay dark pentru contrast peste video */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.3)', // 30% dark overlay
            zIndex: 1,
          }}
        />
      </Box>
    </Box>
  )
}

export default AuthPageWrapper
